export function roundNumber(number, limit) {
  const d = Math.pow(10, limit);
  return Math.round((number + Number.EPSILON) * d) / d;
}
